import '../../../styles/documents/DocumentTile.css';
import { Sparkles } from 'lucide-react';
import { MenuButton } from '../../atoms';

export type DocType = string;

export type DocumentTileProps = {
  id: string;
  name: string;
  type: DocType;
  updated: string;
  documentType?: 'text' | 'doc' | 'ai';
  sourceBadge?: string;
  onOpen?: (id: string) => void;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
};

export default function DocumentTile({
  id, name, type, updated, documentType, sourceBadge = 'Resume Builder', onOpen, onEdit, onDelete,
}: DocumentTileProps) {
  const isPdf = documentType === 'doc' || name.toLowerCase().endsWith('.pdf');
  const isAi = documentType === 'ai';
  const ext = isPdf ? 'PDF' : (isAi ? 'AI' : 'TXT');

  const menuItems = [
    {
      label: 'Edit document',
      onClick: () => onEdit?.(id),
    },
    {
      label: 'Delete document',
      onClick: () => onDelete?.(id),
      danger: true,
    },
  ];

  return (
    <div className="dtile">
      <div
        className="dtile__card"
        onClick={() => onOpen?.(id)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter') onOpen?.(id); }}
      >
        <div className="dtile__thumb">
          <span className={`dtile__ext ${isPdf ? 'dtile__ext--pdf' : isAi ? 'dtile__ext--ai' : 'dtile__ext--txt'}`}>
            {isAi ? (
              <span className="dtile__ai-icon">
                <Sparkles size={16} />
              </span>
            ) : (
              ext
            )}
          </span>
        </div>
        <div className="dtile__name" title={name}>{name}</div>

        <div className="dtile__footer">
          <span className="dtile__type">{type}</span>
          <div className="dtile__menu" data-doc-menu onClick={(e) => e.stopPropagation()}>
            <MenuButton menuItems={menuItems} />
          </div>
        </div>
      </div>
      <div className="dtile__meta">
        <span className="dtile__updated">{updated}</span>
      </div>
    </div>
  );
}